// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsValues = {
  values: {
    user: "User",
    public: "Public",
    tenant: "Tenant",
    application: "Application",
    shared: "Shared",
    sharedOwner: "Shared",
    mySpace: "My Space",
    publicBranding: "Public Branding",
    publicShared: "Public Shared",
    sharedToPublic: "Shared to Public",
    privateOnly: "Private Only",
    unlimited: "Unlimited",
    deletable: "Deletable",
    protected: "Protected",
    unmanaged: "Not Governed",
    none: "None",
    active: "Active",
    readonly: "Read-only",
    disabled: "Disabled",
    read: "Read",
    write: "Write",
    manage: "Manage",
    ownerOnly: "Owner Only",
    spaceAdmin: "Space Admin",
    platformAdmin: "Platform Admin",
    staff: "Exam Staff",
    platformRole: "Platform Role",
  },
} as const;
